export const MINUTES_INTERVAL_ERROR = 'Time not valid';
export const ABA_DURATION_ERROR = 'ABA appointments must be at least 5 minutes';
